import React, { useId } from 'react'
import { Stack, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material'
import { MetricsKey, MetricType } from './index'

type MetricSelectGroupProps = {
  metrics: MetricType
  firstMetric: MetricsKey
  secondMetric: MetricsKey
  handleFirstMetricChange: (e: SelectChangeEvent<MetricsKey>) => void
  handleSecondMetricChange: (e: SelectChangeEvent<MetricsKey>) => void
}

export const MetricSelectGroup: React.FC<MetricSelectGroupProps> = ({
  metrics,
  firstMetric,
  secondMetric,
  handleFirstMetricChange,
  handleSecondMetricChange,
}) => {
  const id = useId()
  return (
    <Stack direction="row" gap={2} my={2} sx={{ width: '100%', maxWidth: 456 }}>
      <FormControl variant="outlined" sx={{ flex: 1, minWidth: 0 }}>
        <InputLabel id={id + 'graph1'}>グラフ項目1</InputLabel>
        <Select labelId={id + 'graph1'} value={firstMetric} onChange={handleFirstMetricChange} label="グラフ項目1">
          {Object.keys(metrics).map((metric) => (
            <MenuItem key={metric} value={metric}>
              {metric}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" sx={{ flex: 1, minWidth: 0 }}>
        <InputLabel id={id + 'graph2'}>グラフ項目2</InputLabel>
        <Select labelId={id + 'graph2'} value={secondMetric} onChange={handleSecondMetricChange} label="グラフ項目2">
          {Object.keys(metrics).map((metric) => (
            <MenuItem key={metric} value={metric}>
              {metric}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  )
}
